import loadable from "@loadable/component"
import PropTypes from "prop-types"
import React, { createContext, useEffect, useState } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import { setExperiment } from "app-store-v2/app/actions"
import menuData from "areas/header/jewlr/menu/data"
import { IS_US, retry } from "helpers/application"
// import Microbanner from "areas/header/microbanner"
import useWindowDimensions from "helpers/window-dimensions"

import HeaderContent from "./header-content"
import HeaderPush from "./header-push"

const AccountMenu = loadable(() =>
  retry(() => import("areas/header/jewlr/menu/mobile/account-menu"))
)
const MobileMenu = loadable(() =>
  retry(() => import("areas/header/jewlr/menu/mobile/main-menu"))
)

export const HeaderMenuContext = createContext()

const Header = ({ desktopNavExp, location, menu, setExperiment }) => {
  const [sticky, setSticky] = useState(false)
  const isTablet = useWindowDimensions().isTablet

  useEffect(() => {
    if (IS_US()) {
      setExperiment({
        desktopNav: desktopNavExp,
      })
    }
  }, [desktopNavExp])

  if (
    location.pathname.includes("/checkout") ||
    location.pathname.includes("/payments")
  ) {
    return ""
  }

  return (
    <HeaderMenuContext.Provider
      value={{ menu: desktopNavExp.variant_id === 1 ? menuData() : menu }}
    >
      <HeaderPush desktopNavExp={desktopNavExp.variant_id} sticky={sticky} />
      <HeaderContent
        location={location}
        setSticky={setSticky}
        sticky={sticky}
      />
      {isTablet ? (
        <>
          <MobileMenu />
          <AccountMenu />
        </>
      ) : (
        <>
          {/* {!location.pathname.includes("cart") && (
            <MediaBox greaterThanOrEqual="desktop">
              <Microbanner />
            </MediaBox>
          )} */}
        </>
      )}
    </HeaderMenuContext.Provider>
  )
}

Header.propTypes = {
  desktopNavExp: PropTypes.object,
  location: PropTypes.object,
  menu: PropTypes.object,
  setExperiment: PropTypes.func,
}

const mapStateToProps = (state) => {
  return {
    desktopNavExp: state.experiment.desktopNav,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setExperiment: (exp) => dispatch(setExperiment(exp)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header))
